export default __webpack_public_path__ + "static/media/Negative Background-01.973c7404.svg";